import strFunc from "@/lib/lyg/string";
import SearchOrderRadio from "@/pcomponents/common/crud/write/radio/radio_arr";
import attend_late_active_ico from "@/img/ico/attend/attend_late_active.png";
import attend_late_ico from "@/img/ico/attend/attend_late.png";
import attend_o_active_ico from "@/img/ico/attend/attend_o_active.png";
import attend_o_ico from "@/img/ico/attend/attend_o.png";
import attend_x_active_ico from "@/img/ico/attend/attend_x_active.png";
import attend_x_ico from "@/img/ico/attend/attend_x.png";
import attend_out_active_ico from "@/img/ico/head/head_attend_ico_active.png";
import attend_out_ico from "@/img/ico/head/head_attend_ico.png";
import opt_purple_ico from "@/img/ico/opt_purple_ico.png";
import excel_purple_ico from "@/img/ico/excel_purple_ico.png";
import print_purple_ico from "@/img/ico/print_purple_ico.png";

function ManageBtnArea(props: any) {
  let myProps = {
    is_under_width: false,
    countInfo: { "tot": 0 },
    listOpt: {},
    list: (inData: any) => { },
    goExcelDown: () => { },
    openListOptPopup: () => { },
    openSendSMSPopup: () => { },
    open_send_push_popup: () => { },
    openOnePopup: (sort: string, is_update: false) => { },
    show_write_page: (is_update: boolean, stu_info: any) => { },
    select_show_write_page: () => { },
    add_stu_bookmark: () => { },
    del_stu_bookmark: () => { },
    openStuEndPopup: () => { },
    goDelete: () => { },
    openAttendPopup: () => { },
    open_sms_select_hp_by_user_popup: () => { },
    onClickPrint: () => { },
    ...props
  };
  let is_under_width = myProps.is_under_width;
  let countInfo = myProps.countInfo;
  let listOpt = myProps.listOpt;

  let stu_end_btn_class_name = "btn-m btn-red ml-1";
  let stu_end_btn_text = "휴/퇴원";
  let is_stu_state_end_search=false;
  if (strFunc.str_in_array(listOpt.s_stu_state, ["now,ready", "", "now"]) == -1) {
    stu_end_btn_class_name = "btn-m btn-blue ml-1";
    stu_end_btn_text = "재원";
    is_stu_state_end_search=true;
  }

  const get_attend_button_tags = () => {
    let attend_in_state_arr = [
      { "value": "attend", "text": "등원", "img": attend_o_ico, "img_active": attend_o_active_ico },
      { "value": "late", "text": "등원(지각)", "img": attend_late_ico, "img_active": attend_late_active_ico },
      { "value": "absent", "text": "결석", "img": attend_x_ico, "img_active": attend_x_active_ico },
      // { "value": "out", "text": "결석", "img": attend_out_ico, "img_active": attend_out_active_ico },
    ];
    let button_tags = attend_in_state_arr.map((item, index) => {
      return (
        <button key={index} className={"ml-1"}
          onClick={() => {
            myProps.openAttendPopup({
              attend_sort: "in",
              attend_sort_detail: item["value"],
            });
          }}>
          <img src={item.img} alt={item.text} style={{ height: "27px" }} />
        </button>
      );
    });
    return button_tags;
  };

  return (
    <div className="basic_list_title_bar_wrap">
      <button className="btn-m btn-yellowish2 ml-1" onClick={() => { myProps.open_sms_select_hp_by_user_popup(); }}>문자</button>
      <button className="btn-m btn-yellowish2 ml-1" onClick={() => { myProps.open_send_push_popup(); }}>푸시</button>
      <span className="ml-2">
        {get_attend_button_tags()}
      </span>
      <span className="ml-1">
        ※ 아이디 앞 ★ 표시는 어플 가입된 학생입니다.
      </span>
      <div className="basic_title_bar_right_box" style={{ top: "0px" }}>
        <button className="btn-m btn-line-gray ml-1" onClick={() => { myProps.openListOptPopup(); }}>
          <img src={opt_purple_ico} style={{height:"18px"}}/>
          <span className="ml-1">화면설정</span>
        </button>
        <button className="btn-m btn-line-gray ml-1" onClick={() => { myProps.goExcelDown(); }}>
          <img src={excel_purple_ico} style={{height:"18px"}}/>
          <span className="ml-1">excel</span>
        </button>
        <button className="btn-m btn-line-gray ml-1" onClick={() => { myProps.onClickPrint(); }}>
          <img src={print_purple_ico} style={{height:"18px"}}/>
          <span className="ml-1">print</span>
        </button>
        <button className="btn-m btn-sky ml-1" onClick={() => { myProps.openOnePopup("write_multy", false); }}>전체등록</button>
        <select className="search-input_select ml-1" name="num_per_page" value={listOpt.num_per_page}
          onChange={(e: any) => {
            myProps.list({
              now_page: 1,
              num_per_page: e.target.value,
            });
          }}>
          <option value="10">페이지당 10개</option>
          <option value="20">페이지당 20개</option>
          <option value="30">페이지당 30개</option>
          <option value="50">페이지당 50개</option>
          <option value="100">페이지당 100개</option>
          <option value="200">페이지당 200개</option>
          <option value="300">페이지당 300개</option>
        </select>
        {is_stu_state_end_search&&
          <button className="btn-m btn-red ml-1" onClick={()=>{myProps.goDelete({});}} >삭제</button>
        }
      </div>
    </div>
  );
};
export default ManageBtnArea;